/**
 * API Configuration
 * Handles backend URL resolution for different environments
 * 
 * Priority:
 * 1. Environment variable REACT_APP_BACKEND_URL (for preview/dev)
 * 2. Same-origin for production domains (tweeporter.ca)
 * 3. Localhost fallback for local development
 */

const getBackendUrl = () => {
  const hostname = window.location.hostname;
  const protocol = window.location.protocol;
  
  // For production domains (tweeporter.ca), use same-origin (relative URLs)
  // This works when frontend and backend are served from the same domain
  if (hostname === 'www.tweeporter.ca' || hostname === 'tweeporter.ca') {
    // Use relative URLs - the backend should be on the same domain
    return '';
  }
  
  // For Emergent preview environments
  if (hostname.includes('.preview.emergentagent.com')) {
    // Use the current preview URL
    return `${protocol}//${hostname}`;
  }
  
  // Use environment variable if set (for other deployments)
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  // Fallback to localhost for local development
  return 'http://localhost:8001';
};

export const API_BASE_URL = getBackendUrl();

// Helper to get full API URL
export const getApiUrl = (path) => {
  const base = API_BASE_URL;
  // Ensure path starts with /
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
};

export default API_BASE_URL;
